import { Component, OnInit } from '@angular/core';
import {LoopBackAuth} from '../services/api-rest.service';

@Component({
  selector: 'cuadro-color-aviso',
  template: `
  <ul class="mb-2 mt-2 list-aviso">
      <li>
          <div class="cuadrado-aviso retirados"></div><span>Retirad@</span>
      </li>
      <li>
          <div class="cuadrado-aviso bg-warning"></div><span>Recuperación</span>
      </li>
      <li>
          <div class="cuadrado-aviso bg-supletorio"></div><span>Supletorio</span>
      </li>
      <li *ngIf="_idToken < 13">
          <div class="cuadrado-aviso bg-remedial"></div><span>Remedial</span>
      </li>
      <li *ngIf="_idToken < 13">
          <div class="cuadrado-aviso bg-danger"></div><span>Gracia</span>
      </li>
      <li *ngIf="_idToken < 13">
          <div class="cuadrado-aviso bg-dark"></div><span>Pierde</span>
      </li>
  </ul>
  `,
  styles: [],
  providers:[LoopBackAuth]
})
export class CuadroColorAvisoComponent implements OnInit {
  _idToken:number;
  constructor(private loopBackAuth: LoopBackAuth) { }

  ngOnInit() {
    this._idToken = this.loopBackAuth.load().acaPerido.id;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/cuadro-color-aviso.component.ts